<template>
  <div>
    <input type="text" v-model="url" />
    <button @click.prevent="handleClick">Click me</button>
    <div>{{ url }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: "",
      response: undefined
    };
  },
  methods: {
    handleClick() {
      this.$http
        .get(this.url, { headers: { "Content-Type": "application/json" } })
        .then(({ data }) => {
          this.response = data;
        })
        .catch(error => {
          this.response = error.response.data;
        });
    }
  }
};
</script>
